import { uniqueName, getColumns } from './IngestionHomePage.Grid';
import actions from '../../../store/actions';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import GridRefresh from '../../../store/state/events/GridRefresh';
import history from '../../../infrastructure/helpers/react/history';
import identityStorage from '../../../infrastructure/authorization/identityStorage';
import React from 'react';
import ServerDataGrid from '../../Common/DataGrid/ServerDataGrid/ServerDataGrid';
import store from '../../../store/store';
import writeUserRoles from '../../../infrastructure/constants/identity/writeUserRoles';
import WarningModal from '../../Common/Modals/WarningModal/WarningModal';
import IngestionConfigGridItem from '../../../types/ingestion/IngestionConfigGridItem';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import { AxiosResponse } from 'axios';
import CopyIngestionConfigModal from '../../Common/Modals/CopyIngestionConfigModal/CopyIngestionConfigModal';
import CopyIngestionConfigModalState from '../../Common/Modals/CopyIngestionConfigModal/CopyIngestionConfigModalState';
import { Unsubscribe } from 'redux';
import ContextMenuOptionType from '../../../types/report/ContextMenuOptionType';
import SelectOption from '../../../infrastructure/types/SelectOption';
import { ReactComponent as SearchIcon } from '../../Common/BootstrapIcons/search.svg';
import { ReactComponent as ClearIcon } from '../../Common/BootstrapIcons/close.svg';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import './IngestionHomePage.scss';
import IngestionConfigInfoModal from '../../Common/Modals/IngestionConfigInfoModal/IngestionConfigInfoModal';
import clientWriteUserRoles from '../../../infrastructure/constants/identity/clientWriteUserRole';

interface State {
    enabled: boolean;
    name: string;
    showWarningModal: boolean;
    message: string;
    config: IngestionConfigGridItem;
    selectedConfigId: number;
    showConfigInfoPopup: boolean;
    configInfo: IngestionConfigGridItem;
}

class IngestionHomePage extends React.Component<any, State> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: any) {
        super(props);

        this.state = {
            enabled: true,
            name: '',
            showWarningModal: false,
            message: '',
            config: {} as IngestionConfigGridItem,
            selectedConfigId: 0,
            showConfigInfoPopup: false,
            configInfo: {} as IngestionConfigGridItem
        };

        this.onEnabledChange = this.onEnabledChange.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onClearClick = this.onClearClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onRemoveConfirmed = this.onRemoveConfirmed.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);
        this.refreshGridListener = this.refreshGridListener.bind(this);
        this.onInfoClick = this.onInfoClick.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.refreshGridListener);

        let name = localStorage.getItem('ingestionConfigSearchText') || '';

        this.setState({ name });
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    refreshGridListener(): void {

        let state = store.getState();

        let proceed = state.action === actions.copyIngestionConfigModal.saveSuccess;

        if (!proceed) {
            return;
        }

        this.refreshGrid();
    }

    onCreateNewClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {

        history.push(appRoutes.ingestion.upload);
    }

    onEnabledChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ enabled: !e.target.checked }, this.refreshGrid);
    }

    onNameChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({ name: e.target.value });

        localStorage.setItem('ingestionConfigSearchText', e.target.value);
    }

    onClearClick(): void {
        this.setState({ name: '' }, () => {
            localStorage.setItem('ingestionConfigSearchText', '');
            this.refreshGrid();
        });
    }

    onSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        this.refreshGrid();
    }

    refreshGrid(): void {

        let payload: GridRefresh = {
            uniqueName: uniqueName,
            useCurrentPage: false
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    }

    onRemoveClick(config: IngestionConfigGridItem): void {

        let message = `Are you sure you want to delete config ${config.name}?`;

        this.setState({ message, showWarningModal: true, config });
    };

    onRemoveConfirmed(): Promise<void> {

        this.setState({ showWarningModal: false });

        let route = urlHelper.buildRoute(['ingestion', this.state.config.id]);

        return httpClient.delete(route).then(this.onSuccess);
    }

    onSuccess(response: AxiosResponse): void {

        let payload: GridRefresh = {
            uniqueName: uniqueName,
            useCurrentPage: true
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    };

    onCopyClick(config: IngestionConfigGridItem) {

        let state = {} as CopyIngestionConfigModalState;

        state.id = config.id as number;
        state.name = `${config.name} - Copy`;
        state.isOpen = true
        store.dispatch({ type: actions.copyIngestionConfigModal.open, payload: state });
    }

    getContextMenuOptions() {
        return [{ text: 'Open config in new tab', value: ContextMenuOptionType.OpenInNewTab } as SelectOption];
    }

    onInfoClick(configInfo: IngestionConfigGridItem): void {
        this.setState({ configInfo, showConfigInfoPopup: true })
    }

    render(): JSX.Element {

        let identity = identityStorage.get();

        let isNotSuperAdmin = clientWriteUserRoles.includes(identity.userRole);

        return (
            <div className="ingestion-home">
                <h3>Ingestion Configs {this.state.enabled ? '' : '(archived)'}</h3>
                {
                    writeUserRoles.includes(identity.userRole) && isNotSuperAdmin &&
                    <div>
                        <button type="button" className="btn cb-btn" onClick={this.onCreateNewClick}>Create New Ingestion Logic</button>
                    </div>
                }

                <div className="flex-container background-whitesmoke padding-left-right-5px margin-top-10px">
                    <div className="row no-gutters mt-4 mb-2">
                        <div className="col-auto">
                            <form onSubmit={this.onSubmit}>
                                <div className="ingestion-search-input-wrapper">
                                    <input
                                        type="text"
                                        value={this.state.name}
                                        onChange={this.onNameChange}
                                        className="form-control ingestion-search-input"
                                        placeholder="Search By Name or Id" />
                                    <div className="ingestion-search-input-actions">
                                        <button
                                            type="submit"
                                            value="Search"
                                            aria-label="Search"
                                            className="custom-icon-button ingestion-search-input-search-button">
                                            <SearchIcon className="ingestion-search-icon color-black-important" title={iconTooltip.search} />
                                        </button>
                                        <span className="ingestion-search-divider"></span>
                                        <button
                                            type="button"
                                            value="Clear"
                                            aria-label="Clear"
                                            className="custom-icon-button ingestion-search-input-clear-button"
                                            onClick={this.onClearClick}>
                                            <ClearIcon className="ingestion-clear-icon color-black-important" title={iconTooltip.clear} />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col ml-2 display-flex align-items-center">
                            <label className="margin-0 display-flex">
                                <input
                                    type="checkbox"
                                    checked={!this.state.enabled}
                                    onChange={this.onEnabledChange} />
                                <span>Archived</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="mb-4">
                    <ServerDataGrid
                        columns={getColumns(this.state.enabled, this.onCopyClick, this.onRemoveClick, this.onInfoClick)}
                        uniqueName={uniqueName}
                        dataSourceRoute="ingestion/page"
                        pageSize={10}
                        getKey={x => x.id}
                        getAdditionalParams={() => this.state} />
                </div>
                {this.state.showWarningModal &&
                    <WarningModal
                        onOkClick={this.onRemoveConfirmed}
                        onCancelClick={() => { this.setState({ showWarningModal: false }); }}
                        title='Remove item'
                        message={this.state.message} />
                }
                <CopyIngestionConfigModal />
                {
                    this.state.showConfigInfoPopup &&
                    <IngestionConfigInfoModal
                        configInfo={this.state.configInfo}
                        onClose={() => { this.setState({ showConfigInfoPopup: false }) }} />

                }
            </div>
        );
    }
}

export default IngestionHomePage;
